import styled from 'styled-components';

import { Button, Icon } from 'components/shared';
import { FormBox } from 'components/shared/form';

export const ShowHideComponentsButtonBox = styled(FormBox)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 15px;
`;

export const ShowHideComponentsButton = styled(Button).attrs({
  transparent: true,
})`
  height: initial;
  display: flex;
  align-items: center;
  gap: 3px;
  padding: 0;
  font-size: var(--font-size-xs);
  opacity: ${(props) => (props.$disabled ? '0.5' : '1')};
  cursor: ${(props) => (props.$disabled ? 'not-allowed' : 'pointer')};
`;

export const ValidationMessage = styled.div`
  color: #d9534f;
  font-size: var(--font-size-xs);
  margin-top: ${(props) => (props.visible ? '8px' : '0')};
  text-align: center;
  visibility: ${(props) => (props.visible ? 'visible' : 'hidden')};
  height: ${(props) => (props.visible ? 'auto' : '0')};
  overflow: hidden;
`;

export const AngleUp = styled(Icon).attrs({
  icon: 'angle',
})`
  width: 9px;
  height: 9px;
  opacity: ${(props) => (props.$disabled ? '0.5' : '1')};
`;

export const AngleDown = styled(Icon).attrs({
  icon: 'angle',
})`
  width: 9px;
  height: 9px;
  transform: rotate(180deg);
`;

export const HiddenFieldsContainer = styled.div`
  display: ${(props) => (props.isVisible ? 'block' : 'none')};
  transition: opacity 0.3s ease-in-out;
  opacity: ${(props) => (props.isVisible ? 1 : 0)};
`;
